<template>
  <el-row :gutter="50" class="edm-row">
    <el-col :span="12">
      <el-input v-model="inn" placeholder="ИНН перевозчика" />
    </el-col>
    <el-col :span="6">
      <el-button
        type="primary"
        class="edm-btn"
        :disabled="!inn"
        @click="checkINN"
      >
        Найти перевозчика
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'CheckInn',
  data() {
    return {
      inn: '',
    }
  },
  methods: {
    checkINN() {
      this.$emit('check', this.inn)
    },
  },
}
</script>
